export interface RequestsResetFormActionType {
  type: '@requests/RESET_FORM';
}

export const resetRequestsForm = (): RequestsResetFormActionType => ({
  type: '@requests/RESET_FORM',
});
